import React from 'react';
import { compose } from 'redux';
import { Form, Input, Button, Typography, notification } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames/bind';
import { getExistRule, validator } from 'utils/validateMessagesUtil';
import { sendEmailToResetPassword } from '../../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);

const FormItem = Form.Item;

class ForgotPasswordForm extends React.Component {
  state = {
    passwordExpired: false
  }
  componentDidMount() {
    const { intl, passwordExpired } = this.props;
    if (passwordExpired) {
      notification.error({
        message: intl.formatMessage({ id: 'global.info.needUpdatePassword' }),
        duration: 5,
      });
    }
    this.setState({ passwordExpired })
  }

  handleSubmit = e => {
    e.preventDefault();
    const { form, sendEmailToResetPassword, history } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        sendEmailToResetPassword(values.email, `${window.location.origin}/auth/resetPassword`, () => history.push('/auth/forgotPassword/checkEmail'));
      }
    });
  }

  render() {
    const { form, intl } = this.props;
    const { passwordExpired } = this.state;
    const { Text } = Typography;
    const { locale } = intl;
    const { getFieldDecorator } = form;

    return (
      <Form className={cx('forgotPassword-form-wrapper')} onSubmit={this.handleSubmit}>
       { passwordExpired &&  <FormattedMessage id="global.info.needUpdatePassword">
          {text => <Text type="danger" className={cx('forgotPassword-form-reset-password-label')}>{text}</Text>}
        </FormattedMessage> }
        <p></p>
        <FormattedMessage id="page.Auth.enterPassWordTip">
          {text => <span className={cx('forgotPassword-form-label')}>{text}</span>}
        </FormattedMessage>
        <FormItem className="mt-md">
          {getFieldDecorator('email', {
              rules: [
                getExistRule('required', 'email', locale, { required: true }),
                {
                  validator: validator.email(locale),
                }
              ],
            })(
              <Input className={cx('forgotPassword-form-input')} />
            )
          }
        </FormItem>
        <FormItem className="mt-md">
          <Button type="primary" htmlType="submit" className={cx('signInBtn')}>
            <FormattedMessage id="page.Auth.nextStep" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const mapDispatchToProps = {
  sendEmailToResetPassword
};

const Enhancer = compose(
  withRouter,
  connect(null, mapDispatchToProps),
  injectIntl,
);

export default Form.create()(Enhancer(ForgotPasswordForm));



// WEBPACK FOOTER //
// ./src/views/Auth/ForgotPassword/components/ForgotPasswordForm.jsx